export default __webpack_public_path__ + "static/media/Course-Icons7.8c1bee79.svg";